import React from "react";
import { RendererProps } from "../shared/renderers";
import { StyledEllipsisCell } from "./styles";

export function CodesListRenderer({ value = [] }: RendererProps<string[]>) {
  const text = value.join(", ");
  return <StyledEllipsisCell title={text}>{text}</StyledEllipsisCell>;
}
